module.exports = __webpack_public_path__ + "img/img_login_bg.05a5be1e.png";